import fetch from '@/utils/fetch';
import filterNull from '@/utils/filterNull';

const model = {
  state: {
    passportName: '',
    passportId: '',
    status: '',
    relationData: [],
    historyData: [],
    listLoading: false,
  },
  reducers: {
    setState(state: any, partialState: any) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { customerAccountDetail }, getState }: any) => ({
    /**
     * 赋值查询参数
     * @param values: 查询匹配值
     */
    setId(id: number) {
      customerAccountDetail.setState({
        passportId: id,
      });
      customerAccountDetail.loadDate();
    },
    /**
     * 获取数据函数
     */
    async loadDate() {
      const { passportId } = getState().customerAccountDetail;
      customerAccountDetail.setState({ listLoading: true });
      const data = await fetch('/saasmerchant/web/account/passportId', {
        params: filterNull({
          passportId,
        }),
      });
      customerAccountDetail.setState({ listLoading: false });
      if (data) {
        const { accountInfo, accountOperation, accountShops } = data;
        customerAccountDetail.setState({
          passportName: accountInfo.passportName,
          passportId: accountInfo.passportId,
          status: accountInfo.status,
          relationData: accountShops,
          historyData: accountOperation,
        });
      }
    },
  }),
};

export default model;
